import { render, staticRenderFns } from "./StatisticGetCatalogUnitTable.vue?vue&type=template&id=f04c676c"
import script from "./StatisticGetCatalogUnitTable.vue?vue&type=script&lang=js"
export * from "./StatisticGetCatalogUnitTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports